import React from 'react';
import styled from 'styled-components';

import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';
import { get } from 'lodash';

import PropTypes from 'prop-types';

const Wrapper = styled.div`
  margin-bottom: 180px;
  color: ${props => props.playButtonColour};
  ${media.large`
    margin-bottom: 0;
  `};

  h2 {
    margin-bottom: var(--fr);
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const ButtonLabel = styled.div`
  text-transform: uppercase;
  font-size: var(--fs-focus);
  font-weight: 400;
  padding: 1rem;
  line-height: 1;
  ${legacyType('focus', 'label', { uppercase: true, lineHeight: false })};
`;

const HeroContent = ({ content, onClick }) => {
  const { heroHeadline, playButtonColour, playButtonLabel, video } = content;

  return (
    <Wrapper playButtonColour={playButtonColour}>
      {heroHeadline && <h2>{heroHeadline}</h2>}
      {get(video, 'fields.videoId') && (
        <ButtonWrapper>
          <button onClick={onClick} aria-label={playButtonLabel}>
            <svg
              fill="#fff"
              height="110"
              viewBox="0 0 48 48"
              width="110"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0h48v48H0z" fill="none" />
              <path d="M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm-4 29V15l12 9-12 9z" />
            </svg>
          </button>
          <ButtonLabel>{playButtonLabel}</ButtonLabel>
        </ButtonWrapper>
      )}
    </Wrapper>
  );
};

HeroContent.propTypes = {
  content: PropTypes.object,
  onClick: PropTypes.func,
};

export default HeroContent;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/videoBlock/HeroContent.js